module.exports = __webpack_public_path__ + "static/media/twitter.407800d3.png";